"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Models_1 = require("../Models");

var GenericRepo_1 = __importDefault(require("./GenericRepo"));

var OrgsRepo =
/** @class */
function (_super) {
  __extends(OrgsRepo, _super);

  function OrgsRepo(coll, messagesRepo, user) {
    var _this = _super.call(this, coll, user) || this;

    _this.messagesRepo = messagesRepo;
    return _this;
  }

  OrgsRepo.prototype.getCurrent = function () {
    var _this = this;

    return new Promise(function (res, rej) {
      _this.coll.findOne({
        org: _this.user.org
      }).then(function (r) {
        if (r) {
          var defaultOrg = new Models_1.Org();

          if (!r.modules) {
            r.modules = [];
          }

          if (!r.config) {
            r.config = __assign({}, defaultOrg.config);
          }

          if (!r.config.douane) {
            r.config.douane = __assign({}, defaultOrg.config.douane);
          }

          r.config.orders = __assign(__assign({}, defaultOrg.config.orders), r.config.orders || {});
          res(r);
        }

        res(undefined);
      });
    });
  };

  OrgsRepo.prototype.addConfigCarrier = function (config) {
    var _this = this;

    return new Promise(function (res, rej) {
      _this.coll.updateOne({
        org: _this.user.org
      }, {
        $push: {
          "config.carriers": config
        }
      }).then(function (r) {
        return res();
      }).catch(function (err) {
        console.log(err);
        rej(err);
      });
    });
  };

  OrgsRepo.prototype.updateConfigCarrier = function (config) {
    var _this = this;

    return new Promise(function (res, rej) {
      _this.coll.updateOne({
        org: _this.user.org,
        "config.carriers.key": config.key
      }, {
        $set: {
          "config.carriers.$": config
        }
      }).then(function (r) {
        return res();
      }).catch(function (err) {
        console.log(err);
        rej(err);
      });
    });
  };

  OrgsRepo.prototype.removeConfigCarrier = function (config) {
    var _this = this;

    return new Promise(function (res, rej) {
      _this.coll.updateOne({
        org: _this.user.org
      }, {
        $pull: {
          "config.carriers": {
            key: config.key
          }
        }
      }).then(function (r) {
        return res();
      }).catch(function (err) {
        console.log(err);
        rej(err);
      });
    });
  };

  OrgsRepo.prototype.updateConfigDouane = function (config) {
    var _this = this;

    return new Promise(function (res, rej) {
      _this.coll.updateOne({
        org: _this.user.org
      }, {
        $set: {
          "config.douane": config
        }
      }).then(function (r) {
        return res();
      }).catch(function (err) {
        console.log(err);
        rej(err);
      });
    });
  };

  OrgsRepo.prototype.updateConfigOrders = function (config) {
    var _this = this;

    return new Promise(function (res, rej) {
      _this.coll.updateOne({
        org: _this.user.org
      }, {
        $set: {
          "config.orders": config
        }
      }).then(function () {
        _this.messagesRepo.save({
          subject: "org",
          org: _this.user.org,
          owner: _this.user.id,
          source: "web",
          data: {
            name: _this.user.org,
            operation: "update"
          }
        });
      }).then(function () {
        res();
      }).catch(function (err) {
        console.error(err);
        rej(err);
      });
    });
  };

  return OrgsRepo;
}(GenericRepo_1.default);

exports.default = OrgsRepo;